import { all, fork } from "redux-saga/effects";
import { createRequest } from "../utils";
import { partnersActions } from ".";
import api from "../../utils/api";

const getPartnersRequest = createRequest(partnersActions.GET_PARTNERS, api.get, (action) => {
  const { from } = action.payload;
  return {
    url: `/partners?&from=${from}&limit=12`,
  };
});

const createPartnerRequest = createRequest(partnersActions.CREATE_PARTNER, api.post, (action) => {
  return {
    url: `/partners`,
    body: action.payload.data,
  };
});

const updatePartnerStatusRequest = createRequest(partnersActions.UPDATE_PARTNER_STATUS, api.post, (action) => {
  const { partnerId, data } = action.payload;
  return {
    url: `/partners/${partnerId}/status`,
    body: data,
  };
});

export default function* rootSaga() {
  yield all([fork(getPartnersRequest), fork(createPartnerRequest), fork(updatePartnerStatusRequest)]);
}
